@if (messages | async; as messages) {
  @if (messages.length > 0) {
    <div class="__messages">
      @for (message of messages; track $index) {
        <app-display-message [type]="message.type" [message]="message.message"></app-display-message>
      }
    </div>
  }
}
